module.exports = __webpack_public_path__ + "img/boooks-info.1fc93bc5.png";